//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { TEMPLATE_API_BASE_URL } from '../http/api-client.tokens';

export interface IClient {
  /**
   * Saves client template configuration for specified clients, LOBs, and appointment types.
   *
   * @param body (optional) The client template configuration request.
   * @returns OK
   */
  saveClientTemplateConfigurations(body?: ClientTemplateConfigurationRequest | undefined): Observable<boolean>;
  /**
   * Gets template configurations for specified clients, LOBs, and appointment types.
   *
   * @param body (optional) The lookup request with client IDs, LOB IDs, and appointment type IDs.
   * @returns OK
   */
  getClientTemplateConfigurations(
    body?: ClientTemplateConfigurationLookupRequest | undefined
  ): Observable<ClientTemplateConfigurationDetailsResponse[]>;
  /**
   * Gets all template configurations for a specific template ID.
   *
   * @param templateId The template ID to retrieve configurations for.
   * @returns OK
   */
  getAllClientTemplateConfigurations(templateId: number): Observable<ClientTemplateConfigurationResponse[]>;
  /**
   * Gets the JSON configuration for a specific client template configuration ID.
   *
   * @param clientTemplateConfigurationId The client template configuration ID.
   * @returns OK
   */
  getClientTemplateConfiguration(clientTemplateConfigurationId: number): Observable<string>;
  /**
   * Delinks the assigned client template configurations.
   *
   * @param body (optional) The list of client template configuration IDs to delink.
   * @returns OK
   */
  delinkClientTemplateConfig(body?: number[] | undefined): Observable<boolean>;
  /**
   * Submits a new configuration request for approval. Creates parent history entry with mapping rows.
   *
   * @param body (optional) The submission request containing template, client, LOB, intervention type, and
   *   configuration JSON.
   * @returns OK
   */
  submitConfigurationRequest(body?: SubmitConfigurationForApprovalRequest | undefined): Observable<number>;
  /**
   * Edits a rejected/draft request (creates child entry with updated JSON).
   *
   * @param requestId The request history ID to edit.
   * @param body (optional) The request body containing the updated configuration JSON.
   * @returns OK
   */
  editConfigurationRequest(requestId: number, body?: UpdateRequestJsonRequest | undefined): Observable<boolean>;
  /**
   * Sends a draft/rejected request for approval.
   *
   * @param requestId The request history ID to send for approval.
   * @param body (optional) Optional request body with updated configuration JSON and submission comments; uses
   *   current JSON if omitted.
   * @returns OK
   */
  sendConfigurationForApproval(requestId: number, body?: UpdateRequestJsonRequest | undefined): Observable<boolean>;
  /**
   * Approves a pending request and promotes config to published table.
   *
   * @param requestId The request history ID to approve.
   * @param body (optional) The request body containing reviewer approval comments.
   * @returns OK
   */
  approveConfigurationRequest(requestId: number, body?: ApproveConfigurationRequest | undefined): Observable<boolean>;
  /**
   * Rejects a pending request.
   *
   * @param requestId The request history ID to reject.
   * @param body (optional) The request body containing reviewer rejection comments.
   * @returns OK
   */
  rejectConfigurationRequest(requestId: number, body?: RejectConfigurationRequest | undefined): Observable<boolean>;
  /**
   * Gets configuration requests for the Requests tab.
   *
   * @param body (optional) The search/filter criteria including template ID, status filter, and search text.
   * @returns OK
   */
  searchConfigurationRequests(
    body?: SearchConfigurationRequest | undefined
  ): Observable<ConfigurationRequestResponse[]>;
  /**
   * Gets the latest JSON for a specific request chain.
   *
   * @param requestId The request history ID.
   * @returns OK
   */
  getConfigurationRequestJson(requestId: number): Observable<string>;
  /**
   * Gets the full history chain for a specific parent request.
   *
   * @param requestId The request history ID.
   * @returns OK
   */
  getConfigurationRequestHistory(requestId: number): Observable<ConfigurationRequestHistoryResponse[]>;
  /**
   * Gets audit trail for a specific clientConfigId (grouped by request chains).
   *
   * @param clientConfigId The client configuration ID to retrieve the audit trail for.
   * @param templateId The template ID to filter the audit trail by.
   * @returns OK
   */
  getConfigurationAuditTrail(
    clientConfigId: number,
    templateId: number
  ): Observable<ConfigurationRequestHistoryResponse[]>;
  /**
   * Soft-deletes a configuration request.
   *
   * @param requestId The request history ID to delete.
   * @returns OK
   */
  deleteConfigurationRequest(requestId: number): Observable<boolean>;
  /**
   * Returns the existing pending approval client config details for the given clients, LOBs,intervention types and
   * template.
   *
   * @param body (optional) The submission request containing clientIds, LOBIds, intervention typeIds and templateId.
   * @returns OK
   */
  getPendingApprovalClientConfig(body?: TemplateConfigurationHistoryLookupRequest | undefined): Observable<boolean>;
  /**
   * Returns the existing draft client config details for the given clients, LOBs,intervention types and template.
   *
   * @param body (optional) The submission request containing clientIds, LOBIds, intervention typeIds and templateId.
   * @returns OK
   */
  getDraftClientConfigs(
    body?: TemplateConfigurationHistoryLookupRequest | undefined
  ): Observable<ClientConfigDetailsResponse[]>;
  /**
   * Returns the deactived client config details for the given request history id, if request history id includes more
   * than one client configuration then it returns empty client configuration details.
   *
   * @param requestId The request history ID to approve.
   * @returns OK
   */
  getDeactivatedClientConfigsForRequest(requestId: number): Observable<ClientConfigDetailsResponse>;
  /**
   * Gets all global variables.
   *
   * @returns OK
   */
  globalVariablesAll(): Observable<GlobalVariableResponse[]>;
  /**
   * Creates a new global variable.
   *
   * @param body (optional) The global variable to create.
   * @returns No Content
   */
  globalVariablesPOST(body?: GlobalVariableRequest | undefined): Observable<void>;
  /**
   * Gets a global variable by ID.
   *
   * @param id The global variable identifier.
   * @returns OK
   */
  globalVariablesGET(id: number): Observable<GlobalVariableResponse>;
  /**
   * Updates an existing global variable.
   *
   * @param id The global variable identifier.
   * @param body (optional) The global variable to update.
   * @returns OK
   */
  globalVariablesPUT(id: number, body?: GlobalVariableRequest | undefined): Observable<GlobalVariableResponse>;
  /**
   * Deletes a global variable by ID.
   *
   * @param id The global variable identifier.
   * @returns No Content
   */
  globalVariablesDELETE(id: number): Observable<void>;
  /** @returns OK */
  health(): Observable<void>;
  /** @returns OK */
  detailed(): Observable<HealthCheckResponse>;
  /**
   * Gets active, resolved clinical rules for one exact template version.
   *
   * @param templateVersionId The identifier of the template version.
   * @returns OK
   */
  clinicalRulesGET(templateVersionId: number): Observable<TemplateClinicalRuleResponse>;
  /**
   * Atomically replaces clinical-rule configuration for one exact template version.
   *
   * @param templateVersionId The identifier of the template version.
   * @param body (optional) The replacement template clinical-rule configuration.
   * @returns No Content
   */
  clinicalRulesPUT(
    templateVersionId: number,
    body?: SaveTemplateClinicalRuleConfigurationRequest | undefined
  ): Observable<void>;
  /**
   * Returns a paginated, filtered, and sorted list of active templates for the template search view.
   *
   * @param body (optional) Search request with pagination, free-text search, column selection, and sorting.
   * @returns OK
   */
  search(body?: TemplateSearchRequest | undefined): Observable<TemplateListItemPagedResult>;
  /**
   * Gets active templates only.
   *
   * @returns OK
   */
  active(): Observable<GetTemplateResponse[]>;
  /**
   * Gets templates by status identifier (active only).
   *
   * @param statusId The template status identifier.
   * @returns OK
   */
  status(statusId: number): Observable<GetTemplateResponse[]>;
  /**
   * Gets a template by ID with all versions.
   *
   * @param id The template identifier.
   * @returns OK
   */
  templates(id: number): Observable<GetTemplateResponse>;
  /**
   * Gets a template by a specific version identifier, with all version history.
   *
   * @param templateVersionId The template version identifier.
   * @returns OK
   */
  versions(templateVersionId: number): Observable<GetTemplateResponse>;
  /**
   * Saves a template (creates new or updates existing) and manages version history.
   *
   * @param validationVersionId (optional) Optional template version ID for lock validation only (not used in entity
   *   creation).
   * @param body (optional) The save template request.
   * @returns OK
   */
  save(
    validationVersionId?: number | undefined,
    body?: SaveTemplateRequest | undefined
  ): Observable<SaveTemplateResponse>;
  /**
   * Approves a template version, transitioning it to Published status.
   *
   * @param templateVersionId The template version identifier to approve.
   * @param body (optional) The approval request with optional review comments.
   * @returns OK
   */
  approve(templateVersionId: number, body?: ApproveTemplateRequest | undefined): Observable<TemplateApprovalResponse>;
  /**
   * Rejects a template version, transitioning it to Rejected status.
   *
   * @param templateVersionId The template version identifier to reject.
   * @param body (optional) The rejection request with required review comments.
   * @returns OK
   */
  reject(templateVersionId: number, body?: RejectTemplateRequest | undefined): Observable<TemplateRejectionResponse>;
  /**
   * Archives a template version, transitioning it to Archived status.
   *
   * @param templateVersionId The template version identifier to archive.
   * @returns OK
   */
  archive(templateVersionId: number): Observable<TemplateArchiveResponse>;
  /**
   * Retrieves a paginated, filtered, and sorted list of templates with assignment status. Supports server-side
   * paging, sorting, free-text search, and optional filtering by status, template name, and modified by. Implemented
   * using Entity Framework LINQ queries for flexibility and performance.
   *
   * @param body (optional) Template list request with pagination and filter parameters.
   * @returns Returns the paged template list with metadata.
   */
  list(body?: TemplateListRequest | undefined): Observable<TemplateListResponsePagedResult>;
  /**
   * Checks if a template name is unique among active templates.
   *
   * @param templateName The template name to check for uniqueness.
   * @returns Returns whether the template name is unique.
   */
  checkUniqueness(templateName: string): Observable<TemplateUniquenessResponse>;
  /**
   * Acquires a lock on a draft template version for the current user.
   *
   * @param templateVersionId The template version identifier.
   * @returns Lock successfully acquired.
   */
  lock(templateVersionId: number): Observable<void>;
  /**
   * Releases a lock on a draft template version. Only the user who holds the lock can release it.
   *
   * @param templateVersionId The template version identifier.
   * @returns Lock successfully released.
   */
  unlock(templateVersionId: number): Observable<void>;
  /**
   * Gets the lock status of a template version.
   *
   * @param templateVersionId The template version identifier.
   * @returns Returns the lock status.
   */
  lockStatus(templateVersionId: number): Observable<LockStatusDto>;
}

@Injectable()
export class Client implements IClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  private http = inject(HttpClient);
  private baseUrl = inject<string>(TEMPLATE_API_BASE_URL);

  /**
   * Saves client template configuration for specified clients, LOBs, and appointment types.
   *
   * @param body (optional) The client template configuration request.
   * @returns OK
   */
  saveClientTemplateConfigurations(body?: ClientTemplateConfigurationRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/save-client-template-configurations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveClientTemplateConfigurations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveClientTemplateConfigurations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processSaveClientTemplateConfigurations(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets template configurations for specified clients, LOBs, and appointment types.
   *
   * @param body (optional) The lookup request with client IDs, LOB IDs, and appointment type IDs.
   * @returns OK
   */
  getClientTemplateConfigurations(
    body?: ClientTemplateConfigurationLookupRequest | undefined
  ): Observable<ClientTemplateConfigurationDetailsResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/get-template-configurations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClientTemplateConfigurations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClientTemplateConfigurations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientTemplateConfigurationDetailsResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientTemplateConfigurationDetailsResponse[]>;
        })
      );
  }

  protected processGetClientTemplateConfigurations(
    response: HttpResponseBase
  ): Observable<ClientTemplateConfigurationDetailsResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ClientTemplateConfigurationDetailsResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all template configurations for a specific template ID.
   *
   * @param templateId The template ID to retrieve configurations for.
   * @returns OK
   */
  getAllClientTemplateConfigurations(templateId: number): Observable<ClientTemplateConfigurationResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/get-all-template-configurations/{templateId}';
    if (templateId === undefined || templateId === null)
      throw new globalThis.Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllClientTemplateConfigurations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllClientTemplateConfigurations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientTemplateConfigurationResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientTemplateConfigurationResponse[]>;
        })
      );
  }

  protected processGetAllClientTemplateConfigurations(
    response: HttpResponseBase
  ): Observable<ClientTemplateConfigurationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ClientTemplateConfigurationResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the JSON configuration for a specific client template configuration ID.
   *
   * @param clientTemplateConfigurationId The client template configuration ID.
   * @returns OK
   */
  getClientTemplateConfiguration(clientTemplateConfigurationId: number): Observable<string> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/get-configuration/{clientTemplateConfigurationId}';
    if (clientTemplateConfigurationId === undefined || clientTemplateConfigurationId === null)
      throw new globalThis.Error("The parameter 'clientTemplateConfigurationId' must be defined.");
    url_ = url_.replace('{clientTemplateConfigurationId}', encodeURIComponent('' + clientTemplateConfigurationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClientTemplateConfiguration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClientTemplateConfiguration(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processGetClientTemplateConfiguration(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Delinks the assigned client template configurations.
   *
   * @param body (optional) The list of client template configuration IDs to delink.
   * @returns OK
   */
  delinkClientTemplateConfig(body?: number[] | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/delink-client-template-config';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelinkClientTemplateConfig(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelinkClientTemplateConfig(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processDelinkClientTemplateConfig(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Submits a new configuration request for approval. Creates parent history entry with mapping rows.
   *
   * @param body (optional) The submission request containing template, client, LOB, intervention type, and
   *   configuration JSON.
   * @returns OK
   */
  submitConfigurationRequest(body?: SubmitConfigurationForApprovalRequest | undefined): Observable<number> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/submit';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubmitConfigurationRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubmitConfigurationRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processSubmitConfigurationRequest(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Edits a rejected/draft request (creates child entry with updated JSON).
   *
   * @param requestId The request history ID to edit.
   * @param body (optional) The request body containing the updated configuration JSON.
   * @returns OK
   */
  editConfigurationRequest(requestId: number, body?: UpdateRequestJsonRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/edit';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditConfigurationRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditConfigurationRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processEditConfigurationRequest(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Sends a draft/rejected request for approval.
   *
   * @param requestId The request history ID to send for approval.
   * @param body (optional) Optional request body with updated configuration JSON and submission comments; uses
   *   current JSON if omitted.
   * @returns OK
   */
  sendConfigurationForApproval(requestId: number, body?: UpdateRequestJsonRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/send-for-approval';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendConfigurationForApproval(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendConfigurationForApproval(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processSendConfigurationForApproval(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Approves a pending request and promotes config to published table.
   *
   * @param requestId The request history ID to approve.
   * @param body (optional) The request body containing reviewer approval comments.
   * @returns OK
   */
  approveConfigurationRequest(requestId: number, body?: ApproveConfigurationRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/approve';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApproveConfigurationRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApproveConfigurationRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processApproveConfigurationRequest(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Rejects a pending request.
   *
   * @param requestId The request history ID to reject.
   * @param body (optional) The request body containing reviewer rejection comments.
   * @returns OK
   */
  rejectConfigurationRequest(requestId: number, body?: RejectConfigurationRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/reject';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRejectConfigurationRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRejectConfigurationRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRejectConfigurationRequest(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets configuration requests for the Requests tab.
   *
   * @param body (optional) The search/filter criteria including template ID, status filter, and search text.
   * @returns OK
   */
  searchConfigurationRequests(
    body?: SearchConfigurationRequest | undefined
  ): Observable<ConfigurationRequestResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchConfigurationRequests(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchConfigurationRequests(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ConfigurationRequestResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ConfigurationRequestResponse[]>;
        })
      );
  }

  protected processSearchConfigurationRequests(response: HttpResponseBase): Observable<ConfigurationRequestResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ConfigurationRequestResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the latest JSON for a specific request chain.
   *
   * @param requestId The request history ID.
   * @returns OK
   */
  getConfigurationRequestJson(requestId: number): Observable<string> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/json';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfigurationRequestJson(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConfigurationRequestJson(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processGetConfigurationRequestJson(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the full history chain for a specific parent request.
   *
   * @param requestId The request history ID.
   * @returns OK
   */
  getConfigurationRequestHistory(requestId: number): Observable<ConfigurationRequestHistoryResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/history';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfigurationRequestHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConfigurationRequestHistory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ConfigurationRequestHistoryResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ConfigurationRequestHistoryResponse[]>;
        })
      );
  }

  protected processGetConfigurationRequestHistory(
    response: HttpResponseBase
  ): Observable<ConfigurationRequestHistoryResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ConfigurationRequestHistoryResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets audit trail for a specific clientConfigId (grouped by request chains).
   *
   * @param clientConfigId The client configuration ID to retrieve the audit trail for.
   * @param templateId The template ID to filter the audit trail by.
   * @returns OK
   */
  getConfigurationAuditTrail(
    clientConfigId: number,
    templateId: number
  ): Observable<ConfigurationRequestHistoryResponse[]> {
    let url_ =
      this.baseUrl +
      '/api/ClientTemplateMapping/configurations/client-configs/{clientConfigId}/templates/{templateId}/audit-trail';
    if (clientConfigId === undefined || clientConfigId === null)
      throw new globalThis.Error("The parameter 'clientConfigId' must be defined.");
    url_ = url_.replace('{clientConfigId}', encodeURIComponent('' + clientConfigId));
    if (templateId === undefined || templateId === null)
      throw new globalThis.Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfigurationAuditTrail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConfigurationAuditTrail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ConfigurationRequestHistoryResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ConfigurationRequestHistoryResponse[]>;
        })
      );
  }

  protected processGetConfigurationAuditTrail(
    response: HttpResponseBase
  ): Observable<ConfigurationRequestHistoryResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ConfigurationRequestHistoryResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Soft-deletes a configuration request.
   *
   * @param requestId The request history ID to delete.
   * @returns OK
   */
  deleteConfigurationRequest(requestId: number): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteConfigurationRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteConfigurationRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processDeleteConfigurationRequest(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns the existing pending approval client config details for the given clients, LOBs,intervention types and
   * template.
   *
   * @param body (optional) The submission request containing clientIds, LOBIds, intervention typeIds and templateId.
   * @returns OK
   */
  getPendingApprovalClientConfig(body?: TemplateConfigurationHistoryLookupRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/pendingApprovalClientConfigs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPendingApprovalClientConfig(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPendingApprovalClientConfig(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processGetPendingApprovalClientConfig(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns the existing draft client config details for the given clients, LOBs,intervention types and template.
   *
   * @param body (optional) The submission request containing clientIds, LOBIds, intervention typeIds and templateId.
   * @returns OK
   */
  getDraftClientConfigs(
    body?: TemplateConfigurationHistoryLookupRequest | undefined
  ): Observable<ClientConfigDetailsResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/draftsClientConfigs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDraftClientConfigs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDraftClientConfigs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientConfigDetailsResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientConfigDetailsResponse[]>;
        })
      );
  }

  protected processGetDraftClientConfigs(response: HttpResponseBase): Observable<ClientConfigDetailsResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ClientConfigDetailsResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns the deactived client config details for the given request history id, if request history id includes more
   * than one client configuration then it returns empty client configuration details.
   *
   * @param requestId The request history ID to approve.
   * @returns OK
   */
  getDeactivatedClientConfigsForRequest(requestId: number): Observable<ClientConfigDetailsResponse> {
    let url_ = this.baseUrl + '/api/ClientTemplateMapping/configurations/requests/{requestId}/publish';
    if (requestId === undefined || requestId === null)
      throw new globalThis.Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDeactivatedClientConfigsForRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDeactivatedClientConfigsForRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientConfigDetailsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientConfigDetailsResponse>;
        })
      );
  }

  protected processGetDeactivatedClientConfigsForRequest(
    response: HttpResponseBase
  ): Observable<ClientConfigDetailsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientConfigDetailsResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all global variables.
   *
   * @returns OK
   */
  globalVariablesAll(): Observable<GlobalVariableResponse[]> {
    let url_ = this.baseUrl + '/api/GlobalVariables';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGlobalVariablesAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGlobalVariablesAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GlobalVariableResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<GlobalVariableResponse[]>;
        })
      );
  }

  protected processGlobalVariablesAll(response: HttpResponseBase): Observable<GlobalVariableResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(GlobalVariableResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new global variable.
   *
   * @param body (optional) The global variable to create.
   * @returns No Content
   */
  globalVariablesPOST(body?: GlobalVariableRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/GlobalVariables';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGlobalVariablesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGlobalVariablesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGlobalVariablesPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets a global variable by ID.
   *
   * @param id The global variable identifier.
   * @returns OK
   */
  globalVariablesGET(id: number): Observable<GlobalVariableResponse> {
    let url_ = this.baseUrl + '/api/GlobalVariables/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGlobalVariablesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGlobalVariablesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GlobalVariableResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GlobalVariableResponse>;
        })
      );
  }

  protected processGlobalVariablesGET(response: HttpResponseBase): Observable<GlobalVariableResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GlobalVariableResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing global variable.
   *
   * @param id The global variable identifier.
   * @param body (optional) The global variable to update.
   * @returns OK
   */
  globalVariablesPUT(id: number, body?: GlobalVariableRequest | undefined): Observable<GlobalVariableResponse> {
    let url_ = this.baseUrl + '/api/GlobalVariables/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGlobalVariablesPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGlobalVariablesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GlobalVariableResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GlobalVariableResponse>;
        })
      );
  }

  protected processGlobalVariablesPUT(response: HttpResponseBase): Observable<GlobalVariableResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GlobalVariableResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes a global variable by ID.
   *
   * @param id The global variable identifier.
   * @returns No Content
   */
  globalVariablesDELETE(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/GlobalVariables/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGlobalVariablesDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGlobalVariablesDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGlobalVariablesDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  health(): Observable<void> {
    let url_ = this.baseUrl + '/health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHealth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHealth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processHealth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Service Unavailable', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  detailed(): Observable<HealthCheckResponse> {
    let url_ = this.baseUrl + '/health/detailed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetailed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetailed(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HealthCheckResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<HealthCheckResponse>;
        })
      );
  }

  protected processDetailed(response: HttpResponseBase): Observable<HealthCheckResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthCheckResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result503: any = null;
          let resultData503 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result503 = HealthCheckResponse.fromJS(resultData503);
          return throwException('Service Unavailable', status, _responseText, _headers, result503);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets active, resolved clinical rules for one exact template version.
   *
   * @param templateVersionId The identifier of the template version.
   * @returns OK
   */
  clinicalRulesGET(templateVersionId: number): Observable<TemplateClinicalRuleResponse> {
    let url_ = this.baseUrl + '/api/template/versions/{templateVersionId}/clinical-rules';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClinicalRulesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClinicalRulesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateClinicalRuleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateClinicalRuleResponse>;
        })
      );
  }

  protected processClinicalRulesGET(response: HttpResponseBase): Observable<TemplateClinicalRuleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateClinicalRuleResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Atomically replaces clinical-rule configuration for one exact template version.
   *
   * @param templateVersionId The identifier of the template version.
   * @param body (optional) The replacement template clinical-rule configuration.
   * @returns No Content
   */
  clinicalRulesPUT(
    templateVersionId: number,
    body?: SaveTemplateClinicalRuleConfigurationRequest | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/template/versions/{templateVersionId}/clinical-rules';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClinicalRulesPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClinicalRulesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processClinicalRulesPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns a paginated, filtered, and sorted list of active templates for the template search view.
   *
   * @param body (optional) Search request with pagination, free-text search, column selection, and sorting.
   * @returns OK
   */
  search(body?: TemplateSearchRequest | undefined): Observable<TemplateListItemPagedResult> {
    let url_ = this.baseUrl + '/api/Template/templates/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateListItemPagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateListItemPagedResult>;
        })
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<TemplateListItemPagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateListItemPagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets active templates only.
   *
   * @returns OK
   */
  active(): Observable<GetTemplateResponse[]> {
    let url_ = this.baseUrl + '/api/Template/templates/active';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActive(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActive(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetTemplateResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<GetTemplateResponse[]>;
        })
      );
  }

  protected processActive(response: HttpResponseBase): Observable<GetTemplateResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(GetTemplateResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets templates by status identifier (active only).
   *
   * @param statusId The template status identifier.
   * @returns OK
   */
  status(statusId: number): Observable<GetTemplateResponse[]> {
    let url_ = this.baseUrl + '/api/Template/templates/status/{statusId}';
    if (statusId === undefined || statusId === null)
      throw new globalThis.Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace('{statusId}', encodeURIComponent('' + statusId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetTemplateResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<GetTemplateResponse[]>;
        })
      );
  }

  protected processStatus(response: HttpResponseBase): Observable<GetTemplateResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(GetTemplateResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets a template by ID with all versions.
   *
   * @param id The template identifier.
   * @returns OK
   */
  templates(id: number): Observable<GetTemplateResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTemplates(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetTemplateResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetTemplateResponse>;
        })
      );
  }

  protected processTemplates(response: HttpResponseBase): Observable<GetTemplateResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetTemplateResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets a template by a specific version identifier, with all version history.
   *
   * @param templateVersionId The template version identifier.
   * @returns OK
   */
  versions(templateVersionId: number): Observable<GetTemplateResponse> {
    let url_ = this.baseUrl + '/api/Template/versions/{templateVersionId}';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVersions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVersions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetTemplateResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetTemplateResponse>;
        })
      );
  }

  protected processVersions(response: HttpResponseBase): Observable<GetTemplateResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetTemplateResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Saves a template (creates new or updates existing) and manages version history.
   *
   * @param validationVersionId (optional) Optional template version ID for lock validation only (not used in entity
   *   creation).
   * @param body (optional) The save template request.
   * @returns OK
   */
  save(
    validationVersionId?: number | undefined,
    body?: SaveTemplateRequest | undefined
  ): Observable<SaveTemplateResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/save?';
    if (validationVersionId === null) throw new globalThis.Error("The parameter 'validationVersionId' cannot be null.");
    else if (validationVersionId !== undefined)
      url_ += 'validationVersionId=' + encodeURIComponent('' + validationVersionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSave(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSave(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SaveTemplateResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SaveTemplateResponse>;
        })
      );
  }

  protected processSave(response: HttpResponseBase): Observable<SaveTemplateResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveTemplateResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Approves a template version, transitioning it to Published status.
   *
   * @param templateVersionId The template version identifier to approve.
   * @param body (optional) The approval request with optional review comments.
   * @returns OK
   */
  approve(templateVersionId: number, body?: ApproveTemplateRequest | undefined): Observable<TemplateApprovalResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/approve';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApprove(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApprove(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateApprovalResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateApprovalResponse>;
        })
      );
  }

  protected processApprove(response: HttpResponseBase): Observable<TemplateApprovalResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateApprovalResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Rejects a template version, transitioning it to Rejected status.
   *
   * @param templateVersionId The template version identifier to reject.
   * @param body (optional) The rejection request with required review comments.
   * @returns OK
   */
  reject(templateVersionId: number, body?: RejectTemplateRequest | undefined): Observable<TemplateRejectionResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/reject';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReject(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReject(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateRejectionResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateRejectionResponse>;
        })
      );
  }

  protected processReject(response: HttpResponseBase): Observable<TemplateRejectionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateRejectionResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Archives a template version, transitioning it to Archived status.
   *
   * @param templateVersionId The template version identifier to archive.
   * @returns OK
   */
  archive(templateVersionId: number): Observable<TemplateArchiveResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/archive';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processArchive(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processArchive(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateArchiveResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateArchiveResponse>;
        })
      );
  }

  protected processArchive(response: HttpResponseBase): Observable<TemplateArchiveResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateArchiveResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a paginated, filtered, and sorted list of templates with assignment status. Supports server-side
   * paging, sorting, free-text search, and optional filtering by status, template name, and modified by. Implemented
   * using Entity Framework LINQ queries for flexibility and performance.
   *
   * @param body (optional) Template list request with pagination and filter parameters.
   * @returns Returns the paged template list with metadata.
   */
  list(body?: TemplateListRequest | undefined): Observable<TemplateListResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Template/templates/list';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateListResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateListResponsePagedResult>;
        })
      );
  }

  protected processList(response: HttpResponseBase): Observable<TemplateListResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateListResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Invalid request parameters.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Checks if a template name is unique among active templates.
   *
   * @param templateName The template name to check for uniqueness.
   * @returns Returns whether the template name is unique.
   */
  checkUniqueness(templateName: string): Observable<TemplateUniquenessResponse> {
    let url_ = this.baseUrl + '/api/Template/templates/check-uniqueness?';
    if (templateName === undefined || templateName === null)
      throw new globalThis.Error("The parameter 'templateName' must be defined and cannot be null.");
    else url_ += 'templateName=' + encodeURIComponent('' + templateName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckUniqueness(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckUniqueness(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateUniquenessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateUniquenessResponse>;
        })
      );
  }

  protected processCheckUniqueness(response: HttpResponseBase): Observable<TemplateUniquenessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateUniquenessResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Template name is required or invalid.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Acquires a lock on a draft template version for the current user.
   *
   * @param templateVersionId The template version identifier.
   * @returns Lock successfully acquired.
   */
  lock(templateVersionId: number): Observable<void> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/lock';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLock(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLock(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Template version not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException(
            'Template version is already locked by another user.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Releases a lock on a draft template version. Only the user who holds the lock can release it.
   *
   * @param templateVersionId The template version identifier.
   * @returns Lock successfully released.
   */
  unlock(templateVersionId: number): Observable<void> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/unlock';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnlock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnlock(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUnlock(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Current user does not hold the lock.', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Template version not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the lock status of a template version.
   *
   * @param templateVersionId The template version identifier.
   * @returns Returns the lock status.
   */
  lockStatus(templateVersionId: number): Observable<LockStatusDto> {
    let url_ = this.baseUrl + '/api/Template/templates/versions/{templateVersionId}/lock-status';
    if (templateVersionId === undefined || templateVersionId === null)
      throw new globalThis.Error("The parameter 'templateVersionId' must be defined.");
    url_ = url_.replace('{templateVersionId}', encodeURIComponent('' + templateVersionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLockStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLockStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LockStatusDto>;
            }
          } else return _observableThrow(response_) as any as Observable<LockStatusDto>;
        })
      );
  }

  protected processLockStatus(response: HttpResponseBase): Observable<LockStatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LockStatusDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Template version not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export class ApproveConfigurationRequest implements IApproveConfigurationRequest {
  reviewComments?: string | undefined;

  constructor(data?: IApproveConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reviewComments = _data['reviewComments'];
    }
  }

  static fromJS(data: any): ApproveConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ApproveConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reviewComments'] = this.reviewComments;
    return data;
  }
}

export interface IApproveConfigurationRequest {
  reviewComments?: string | undefined;
}

export class ApproveTemplateRequest implements IApproveTemplateRequest {
  reviewComments!: string;

  constructor(data?: IApproveTemplateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reviewComments = _data['reviewComments'];
    }
  }

  static fromJS(data: any): ApproveTemplateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ApproveTemplateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reviewComments'] = this.reviewComments;
    return data;
  }
}

export interface IApproveTemplateRequest {
  reviewComments: string;
}

export class ClientConfigDetailsResponse implements IClientConfigDetailsResponse {
  clientId?: number;
  clientName?: string | undefined;
  lobId?: number;
  lobName?: string | undefined;
  interventionTypeId?: number;
  interventionTypeName?: string | undefined;

  constructor(data?: IClientConfigDetailsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.lobId = _data['lobId'];
      this.lobName = _data['lobName'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.interventionTypeName = _data['interventionTypeName'];
    }
  }

  static fromJS(data: any): ClientConfigDetailsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientConfigDetailsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['lobId'] = this.lobId;
    data['lobName'] = this.lobName;
    data['interventionTypeId'] = this.interventionTypeId;
    data['interventionTypeName'] = this.interventionTypeName;
    return data;
  }
}

export interface IClientConfigDetailsResponse {
  clientId?: number;
  clientName?: string | undefined;
  lobId?: number;
  lobName?: string | undefined;
  interventionTypeId?: number;
  interventionTypeName?: string | undefined;
}

export class ClientTemplateConfigurationDetailsResponse implements IClientTemplateConfigurationDetailsResponse {
  clientTemplateConfigurationId?: number;
  templateId?: number;
  clientConfigId?: number;
  clientName?: string | undefined;
  lobName?: string | undefined;
  interventionTypeName?: string | undefined;
  templateName?: string | undefined;
  assessmentStrategyTypeId?: number;
  templatePublishedQuestionareId?: string | undefined;

  constructor(data?: IClientTemplateConfigurationDetailsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientTemplateConfigurationId = _data['clientTemplateConfigurationId'];
      this.templateId = _data['templateId'];
      this.clientConfigId = _data['clientConfigId'];
      this.clientName = _data['clientName'];
      this.lobName = _data['lobName'];
      this.interventionTypeName = _data['interventionTypeName'];
      this.templateName = _data['templateName'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.templatePublishedQuestionareId = _data['templatePublishedQuestionareId'];
    }
  }

  static fromJS(data: any): ClientTemplateConfigurationDetailsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientTemplateConfigurationDetailsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientTemplateConfigurationId'] = this.clientTemplateConfigurationId;
    data['templateId'] = this.templateId;
    data['clientConfigId'] = this.clientConfigId;
    data['clientName'] = this.clientName;
    data['lobName'] = this.lobName;
    data['interventionTypeName'] = this.interventionTypeName;
    data['templateName'] = this.templateName;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['templatePublishedQuestionareId'] = this.templatePublishedQuestionareId;
    return data;
  }
}

export interface IClientTemplateConfigurationDetailsResponse {
  clientTemplateConfigurationId?: number;
  templateId?: number;
  clientConfigId?: number;
  clientName?: string | undefined;
  lobName?: string | undefined;
  interventionTypeName?: string | undefined;
  templateName?: string | undefined;
  assessmentStrategyTypeId?: number;
  templatePublishedQuestionareId?: string | undefined;
}

export class ClientTemplateConfigurationLookupRequest implements IClientTemplateConfigurationLookupRequest {
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  assessmentStrategyTypeId?: number;

  constructor(data?: IClientTemplateConfigurationLookupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['clientIds'])) {
        this.clientIds = [] as any;
        for (let item of _data['clientIds']) this.clientIds!.push(item);
      }
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
    }
  }

  static fromJS(data: any): ClientTemplateConfigurationLookupRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ClientTemplateConfigurationLookupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.clientIds)) {
      data['clientIds'] = [];
      for (let item of this.clientIds) data['clientIds'].push(item);
    }
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    return data;
  }
}

export interface IClientTemplateConfigurationLookupRequest {
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  assessmentStrategyTypeId?: number;
}

export class ClientTemplateConfigurationRequest implements IClientTemplateConfigurationRequest {
  templateConfigurationId?: number | undefined;
  templateId?: number;
  assessmentStrategyTypeId?: number;
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  effectiveDate?: string;
  templateConfig?: ClientTemplateJsonSchema;

  constructor(data?: IClientTemplateConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateConfigurationId = _data['templateConfigurationId'];
      this.templateId = _data['templateId'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      if (Array.isArray(_data['clientIds'])) {
        this.clientIds = [] as any;
        for (let item of _data['clientIds']) this.clientIds!.push(item);
      }
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      this.effectiveDate = _data['effectiveDate'];
      this.templateConfig = _data['templateConfig']
        ? ClientTemplateJsonSchema.fromJS(_data['templateConfig'])
        : (undefined as any);
    }
  }

  static fromJS(data: any): ClientTemplateConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ClientTemplateConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateConfigurationId'] = this.templateConfigurationId;
    data['templateId'] = this.templateId;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    if (Array.isArray(this.clientIds)) {
      data['clientIds'] = [];
      for (let item of this.clientIds) data['clientIds'].push(item);
    }
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    data['effectiveDate'] = this.effectiveDate;
    data['templateConfig'] = this.templateConfig ? this.templateConfig.toJSON() : (undefined as any);
    return data;
  }
}

export interface IClientTemplateConfigurationRequest {
  templateConfigurationId?: number | undefined;
  templateId?: number;
  assessmentStrategyTypeId?: number;
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  effectiveDate?: string;
  templateConfig?: ClientTemplateJsonSchema;
}

export class ClientTemplateConfigurationResponse implements IClientTemplateConfigurationResponse {
  clientTemplateConfigurationId?: number;
  clientConfigId?: number;
  clientId?: number;
  lobId?: number;
  interventionTypeId?: number;
  clientName?: string | undefined;
  lobName?: string | undefined;
  interventionTypeName?: string | undefined;
  assessmentStrategyTypeId?: number;
  assignedBy?: string | undefined;
  configurationStatusId?: number;
  status?: string | undefined;
  comments?: string | undefined;
  effectiveDate?: string;
  lastUpdatedDate?: string | undefined;
  templatePublishedQuestionareId?: string | undefined;

  constructor(data?: IClientTemplateConfigurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientTemplateConfigurationId = _data['clientTemplateConfigurationId'];
      this.clientConfigId = _data['clientConfigId'];
      this.clientId = _data['clientId'];
      this.lobId = _data['lobId'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.clientName = _data['clientName'];
      this.lobName = _data['lobName'];
      this.interventionTypeName = _data['interventionTypeName'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.assignedBy = _data['assignedBy'];
      this.configurationStatusId = _data['configurationStatusId'];
      this.status = _data['status'];
      this.comments = _data['comments'];
      this.effectiveDate = _data['effectiveDate'];
      this.lastUpdatedDate = _data['lastUpdatedDate'];
      this.templatePublishedQuestionareId = _data['templatePublishedQuestionareId'];
    }
  }

  static fromJS(data: any): ClientTemplateConfigurationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientTemplateConfigurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientTemplateConfigurationId'] = this.clientTemplateConfigurationId;
    data['clientConfigId'] = this.clientConfigId;
    data['clientId'] = this.clientId;
    data['lobId'] = this.lobId;
    data['interventionTypeId'] = this.interventionTypeId;
    data['clientName'] = this.clientName;
    data['lobName'] = this.lobName;
    data['interventionTypeName'] = this.interventionTypeName;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['assignedBy'] = this.assignedBy;
    data['configurationStatusId'] = this.configurationStatusId;
    data['status'] = this.status;
    data['comments'] = this.comments;
    data['effectiveDate'] = this.effectiveDate;
    data['lastUpdatedDate'] = this.lastUpdatedDate;
    data['templatePublishedQuestionareId'] = this.templatePublishedQuestionareId;
    return data;
  }
}

export interface IClientTemplateConfigurationResponse {
  clientTemplateConfigurationId?: number;
  clientConfigId?: number;
  clientId?: number;
  lobId?: number;
  interventionTypeId?: number;
  clientName?: string | undefined;
  lobName?: string | undefined;
  interventionTypeName?: string | undefined;
  assessmentStrategyTypeId?: number;
  assignedBy?: string | undefined;
  configurationStatusId?: number;
  status?: string | undefined;
  comments?: string | undefined;
  effectiveDate?: string;
  lastUpdatedDate?: string | undefined;
  templatePublishedQuestionareId?: string | undefined;
}

export class ClientTemplateJsonSchema implements IClientTemplateJsonSchema {
  sections?: Section[] | undefined;

  constructor(data?: IClientTemplateJsonSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['sections'])) {
        this.sections = [] as any;
        for (let item of _data['sections']) this.sections!.push(Section.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClientTemplateJsonSchema {
    data = typeof data === 'object' ? data : {};
    let result = new ClientTemplateJsonSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.sections)) {
      data['sections'] = [];
      for (let item of this.sections) data['sections'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClientTemplateJsonSchema {
  sections?: Section[] | undefined;
}

export class ClinicalRuleConflictDefinitionResponse implements IClinicalRuleConflictDefinitionResponse {
  conflictDefinitionId?: number;
  conflictType?: number;
  note?: string | undefined;
  displayOrder?: number;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;
  sets?: ClinicalRuleConflictSetResponse[] | undefined;

  constructor(data?: IClinicalRuleConflictDefinitionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conflictDefinitionId = _data['conflictDefinitionId'];
      this.conflictType = _data['conflictType'];
      this.note = _data['note'];
      this.displayOrder = _data['displayOrder'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(ClinicalRuleIcdCodeResponse.fromJS(item));
      }
      if (Array.isArray(_data['sets'])) {
        this.sets = [] as any;
        for (let item of _data['sets']) this.sets!.push(ClinicalRuleConflictSetResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClinicalRuleConflictDefinitionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicalRuleConflictDefinitionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conflictDefinitionId'] = this.conflictDefinitionId;
    data['conflictType'] = this.conflictType;
    data['note'] = this.note;
    data['displayOrder'] = this.displayOrder;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.sets)) {
      data['sets'] = [];
      for (let item of this.sets) data['sets'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClinicalRuleConflictDefinitionResponse {
  conflictDefinitionId?: number;
  conflictType?: number;
  note?: string | undefined;
  displayOrder?: number;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;
  sets?: ClinicalRuleConflictSetResponse[] | undefined;
}

export class ClinicalRuleConflictSetResponse implements IClinicalRuleConflictSetResponse {
  conflictSetId?: number;
  name?: string | undefined;
  displayOrder?: number;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;

  constructor(data?: IClinicalRuleConflictSetResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conflictSetId = _data['conflictSetId'];
      this.name = _data['name'];
      this.displayOrder = _data['displayOrder'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(ClinicalRuleIcdCodeResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClinicalRuleConflictSetResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicalRuleConflictSetResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conflictSetId'] = this.conflictSetId;
    data['name'] = this.name;
    data['displayOrder'] = this.displayOrder;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClinicalRuleConflictSetResponse {
  conflictSetId?: number;
  name?: string | undefined;
  displayOrder?: number;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;
}

export class ClinicalRuleDefinitionResponse implements IClinicalRuleDefinitionResponse {
  ruleId?: number;
  ruleGroupId?: number;
  ruleName?: string | undefined;
  ruleGroupName?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  matchType?: string | undefined;
  severity?: string | undefined;
  category?: string | undefined;
  isActive?: boolean;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;
  conflictDefinitions?: ClinicalRuleConflictDefinitionResponse[] | undefined;

  constructor(data?: IClinicalRuleDefinitionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.ruleName = _data['ruleName'];
      this.ruleGroupName = _data['ruleGroupName'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      this.matchType = _data['matchType'];
      this.severity = _data['severity'];
      this.category = _data['category'];
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(ClinicalRuleIcdCodeResponse.fromJS(item));
      }
      if (Array.isArray(_data['conflictDefinitions'])) {
        this.conflictDefinitions = [] as any;
        for (let item of _data['conflictDefinitions'])
          this.conflictDefinitions!.push(ClinicalRuleConflictDefinitionResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClinicalRuleDefinitionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicalRuleDefinitionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['ruleGroupId'] = this.ruleGroupId;
    data['ruleName'] = this.ruleName;
    data['ruleGroupName'] = this.ruleGroupName;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    data['matchType'] = this.matchType;
    data['severity'] = this.severity;
    data['category'] = this.category;
    data['isActive'] = this.isActive;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.conflictDefinitions)) {
      data['conflictDefinitions'] = [];
      for (let item of this.conflictDefinitions)
        data['conflictDefinitions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClinicalRuleDefinitionResponse {
  ruleId?: number;
  ruleGroupId?: number;
  ruleName?: string | undefined;
  ruleGroupName?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  matchType?: string | undefined;
  severity?: string | undefined;
  category?: string | undefined;
  isActive?: boolean;
  icdCodes?: ClinicalRuleIcdCodeResponse[] | undefined;
  conflictDefinitions?: ClinicalRuleConflictDefinitionResponse[] | undefined;
}

export class ClinicalRuleIcdCodeResponse implements IClinicalRuleIcdCodeResponse {
  code?: string | undefined;
  displayOrder?: number;

  constructor(data?: IClinicalRuleIcdCodeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.displayOrder = _data['displayOrder'];
    }
  }

  static fromJS(data: any): ClinicalRuleIcdCodeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicalRuleIcdCodeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['displayOrder'] = this.displayOrder;
    return data;
  }
}

export interface IClinicalRuleIcdCodeResponse {
  code?: string | undefined;
  displayOrder?: number;
}

export class ConfigurationRequestHistoryResponse implements IConfigurationRequestHistoryResponse {
  historyId?: number;
  parentRequestId?: number | undefined;
  templateId?: number;
  configurationStatusId?: number;
  status?: string | undefined;
  clientConfigureJson?: string | undefined;
  isClientConfigureJsonUpdated?: boolean;
  isRequestPublished?: boolean;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  assignedBy?: string | undefined;
  templateName?: string | undefined;
  createdDate?: string | undefined;
  effectiveDate?: string;

  constructor(data?: IConfigurationRequestHistoryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.historyId = _data['historyId'];
      this.parentRequestId = _data['parentRequestId'];
      this.templateId = _data['templateId'];
      this.configurationStatusId = _data['configurationStatusId'];
      this.status = _data['status'];
      this.clientConfigureJson = _data['clientConfigureJson'];
      this.isClientConfigureJsonUpdated = _data['isClientConfigureJsonUpdated'];
      this.isRequestPublished = _data['isRequestPublished'];
      this.reviewComments = _data['reviewComments'];
      this.submittedBy = _data['submittedBy'];
      this.submittedDate = _data['submittedDate'];
      this.approvedBy = _data['approvedBy'];
      this.approvedDate = _data['approvedDate'];
      this.rejectedBy = _data['rejectedBy'];
      this.rejectedDate = _data['rejectedDate'];
      this.assignedBy = _data['assignedBy'];
      this.templateName = _data['templateName'];
      this.createdDate = _data['createdDate'];
      this.effectiveDate = _data['effectiveDate'];
    }
  }

  static fromJS(data: any): ConfigurationRequestHistoryResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ConfigurationRequestHistoryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['historyId'] = this.historyId;
    data['parentRequestId'] = this.parentRequestId;
    data['templateId'] = this.templateId;
    data['configurationStatusId'] = this.configurationStatusId;
    data['status'] = this.status;
    data['clientConfigureJson'] = this.clientConfigureJson;
    data['isClientConfigureJsonUpdated'] = this.isClientConfigureJsonUpdated;
    data['isRequestPublished'] = this.isRequestPublished;
    data['reviewComments'] = this.reviewComments;
    data['submittedBy'] = this.submittedBy;
    data['submittedDate'] = this.submittedDate;
    data['approvedBy'] = this.approvedBy;
    data['approvedDate'] = this.approvedDate;
    data['rejectedBy'] = this.rejectedBy;
    data['rejectedDate'] = this.rejectedDate;
    data['assignedBy'] = this.assignedBy;
    data['templateName'] = this.templateName;
    data['createdDate'] = this.createdDate;
    data['effectiveDate'] = this.effectiveDate;
    return data;
  }
}

export interface IConfigurationRequestHistoryResponse {
  historyId?: number;
  parentRequestId?: number | undefined;
  templateId?: number;
  configurationStatusId?: number;
  status?: string | undefined;
  clientConfigureJson?: string | undefined;
  isClientConfigureJsonUpdated?: boolean;
  isRequestPublished?: boolean;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  assignedBy?: string | undefined;
  templateName?: string | undefined;
  createdDate?: string | undefined;
  effectiveDate?: string;
}

export class ConfigurationRequestResponse implements IConfigurationRequestResponse {
  requestId?: number;
  templateId?: number;
  mappingsCount?: number;
  clientNames?: string | undefined;
  lobNames?: string | undefined;
  interventionTypeNames?: string | undefined;
  configurationStatusId?: number;
  status?: string | undefined;
  assignedBy?: string | undefined;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  lastUpdatedDate?: string | undefined;
  effectiveDate?: string;
  isDeactivate?: boolean;

  constructor(data?: IConfigurationRequestResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestId = _data['requestId'];
      this.templateId = _data['templateId'];
      this.mappingsCount = _data['mappingsCount'];
      this.clientNames = _data['clientNames'];
      this.lobNames = _data['lobNames'];
      this.interventionTypeNames = _data['interventionTypeNames'];
      this.configurationStatusId = _data['configurationStatusId'];
      this.status = _data['status'];
      this.assignedBy = _data['assignedBy'];
      this.submitComments = _data['submitComments'];
      this.reviewComments = _data['reviewComments'];
      this.submittedBy = _data['submittedBy'];
      this.submittedDate = _data['submittedDate'];
      this.approvedBy = _data['approvedBy'];
      this.approvedDate = _data['approvedDate'];
      this.rejectedBy = _data['rejectedBy'];
      this.rejectedDate = _data['rejectedDate'];
      this.lastUpdatedDate = _data['lastUpdatedDate'];
      this.effectiveDate = _data['effectiveDate'];
      this.isDeactivate = _data['isDeactivate'];
    }
  }

  static fromJS(data: any): ConfigurationRequestResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ConfigurationRequestResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['requestId'] = this.requestId;
    data['templateId'] = this.templateId;
    data['mappingsCount'] = this.mappingsCount;
    data['clientNames'] = this.clientNames;
    data['lobNames'] = this.lobNames;
    data['interventionTypeNames'] = this.interventionTypeNames;
    data['configurationStatusId'] = this.configurationStatusId;
    data['status'] = this.status;
    data['assignedBy'] = this.assignedBy;
    data['submitComments'] = this.submitComments;
    data['reviewComments'] = this.reviewComments;
    data['submittedBy'] = this.submittedBy;
    data['submittedDate'] = this.submittedDate;
    data['approvedBy'] = this.approvedBy;
    data['approvedDate'] = this.approvedDate;
    data['rejectedBy'] = this.rejectedBy;
    data['rejectedDate'] = this.rejectedDate;
    data['lastUpdatedDate'] = this.lastUpdatedDate;
    data['effectiveDate'] = this.effectiveDate;
    data['isDeactivate'] = this.isDeactivate;
    return data;
  }
}

export interface IConfigurationRequestResponse {
  requestId?: number;
  templateId?: number;
  mappingsCount?: number;
  clientNames?: string | undefined;
  lobNames?: string | undefined;
  interventionTypeNames?: string | undefined;
  configurationStatusId?: number;
  status?: string | undefined;
  assignedBy?: string | undefined;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  lastUpdatedDate?: string | undefined;
  effectiveDate?: string;
  isDeactivate?: boolean;
}

export class ConflictingDiagnosisRuleCategoryConfigurationResponse implements IConflictingDiagnosisRuleCategoryConfigurationResponse {
  enabled?: boolean;
  rules?: ClinicalRuleDefinitionResponse[] | undefined;

  constructor(data?: IConflictingDiagnosisRuleCategoryConfigurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enabled = _data['enabled'];
      if (Array.isArray(_data['rules'])) {
        this.rules = [] as any;
        for (let item of _data['rules']) this.rules!.push(ClinicalRuleDefinitionResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConflictingDiagnosisRuleCategoryConfigurationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ConflictingDiagnosisRuleCategoryConfigurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['enabled'] = this.enabled;
    if (Array.isArray(this.rules)) {
      data['rules'] = [];
      for (let item of this.rules) data['rules'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IConflictingDiagnosisRuleCategoryConfigurationResponse {
  enabled?: boolean;
  rules?: ClinicalRuleDefinitionResponse[] | undefined;
}

export class DoNotCodeRuleCategoryConfigurationResponse implements IDoNotCodeRuleCategoryConfigurationResponse {
  enabled?: boolean;
  rules?: DoNotCodeRuleDefinitionResponse[] | undefined;

  constructor(data?: IDoNotCodeRuleCategoryConfigurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enabled = _data['enabled'];
      if (Array.isArray(_data['rules'])) {
        this.rules = [] as any;
        for (let item of _data['rules']) this.rules!.push(DoNotCodeRuleDefinitionResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DoNotCodeRuleCategoryConfigurationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DoNotCodeRuleCategoryConfigurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['enabled'] = this.enabled;
    if (Array.isArray(this.rules)) {
      data['rules'] = [];
      for (let item of this.rules) data['rules'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IDoNotCodeRuleCategoryConfigurationResponse {
  enabled?: boolean;
  rules?: DoNotCodeRuleDefinitionResponse[] | undefined;
}

export class DoNotCodeRuleDefinitionResponse implements IDoNotCodeRuleDefinitionResponse {
  ruleId?: number;
  ruleGroupId?: number;
  ruleName?: string | undefined;
  ruleGroupName?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  matchType?: string | undefined;
  severity?: string | undefined;
  category?: string | undefined;
  isActive?: boolean;
  icdCodes?: string[] | undefined;

  constructor(data?: IDoNotCodeRuleDefinitionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.ruleName = _data['ruleName'];
      this.ruleGroupName = _data['ruleGroupName'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      this.matchType = _data['matchType'];
      this.severity = _data['severity'];
      this.category = _data['category'];
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): DoNotCodeRuleDefinitionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DoNotCodeRuleDefinitionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['ruleGroupId'] = this.ruleGroupId;
    data['ruleName'] = this.ruleName;
    data['ruleGroupName'] = this.ruleGroupName;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    data['matchType'] = this.matchType;
    data['severity'] = this.severity;
    data['category'] = this.category;
    data['isActive'] = this.isActive;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item);
    }
    return data;
  }
}

export interface IDoNotCodeRuleDefinitionResponse {
  ruleId?: number;
  ruleGroupId?: number;
  ruleName?: string | undefined;
  ruleGroupName?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  matchType?: string | undefined;
  severity?: string | undefined;
  category?: string | undefined;
  isActive?: boolean;
  icdCodes?: string[] | undefined;
}

export class DocumentationRequiredConfigurationResponse implements IDocumentationRequiredConfigurationResponse {
  ruleSnapshot?: { [key: string]: DocumentationRequiredRuleSnapshotResponse } | undefined;
  rules?: DocumentationRequiredRuleResponse[] | undefined;

  constructor(data?: IDocumentationRequiredConfigurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['ruleSnapshot']) {
        this.ruleSnapshot = {} as any;
        for (let key in _data['ruleSnapshot']) {
          if (_data['ruleSnapshot'].hasOwnProperty(key))
            (this.ruleSnapshot as any)![key] = _data['ruleSnapshot'][key]
              ? DocumentationRequiredRuleSnapshotResponse.fromJS(_data['ruleSnapshot'][key])
              : new DocumentationRequiredRuleSnapshotResponse();
        }
      }
      if (Array.isArray(_data['rules'])) {
        this.rules = [] as any;
        for (let item of _data['rules']) this.rules!.push(DocumentationRequiredRuleResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DocumentationRequiredConfigurationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentationRequiredConfigurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.ruleSnapshot) {
      data['ruleSnapshot'] = {};
      for (let key in this.ruleSnapshot) {
        if (this.ruleSnapshot.hasOwnProperty(key))
          (data['ruleSnapshot'] as any)[key] = this.ruleSnapshot[key]
            ? this.ruleSnapshot[key].toJSON()
            : (undefined as any);
      }
    }
    if (Array.isArray(this.rules)) {
      data['rules'] = [];
      for (let item of this.rules) data['rules'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IDocumentationRequiredConfigurationResponse {
  ruleSnapshot?: { [key: string]: DocumentationRequiredRuleSnapshotResponse } | undefined;
  rules?: DocumentationRequiredRuleResponse[] | undefined;
}

export class DocumentationRequiredRuleResponse implements IDocumentationRequiredRuleResponse {
  id?: string | undefined;
  operator?: string | undefined;
  groupId?: number;
  groupName?: string | undefined;
  ruleIds?: number[] | undefined;
  ruleNames?: string[] | undefined;
  evidenceLinkId?: string | undefined;
  evidencePathText?: string | undefined;
  condition?: string | undefined;
  values?: string[] | undefined;
  rowGroupId?: string | undefined;
  displayOrder?: number;

  constructor(data?: IDocumentationRequiredRuleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.operator = _data['operator'];
      this.groupId = _data['groupId'];
      this.groupName = _data['groupName'];
      if (Array.isArray(_data['ruleIds'])) {
        this.ruleIds = [] as any;
        for (let item of _data['ruleIds']) this.ruleIds!.push(item);
      }
      if (Array.isArray(_data['ruleNames'])) {
        this.ruleNames = [] as any;
        for (let item of _data['ruleNames']) this.ruleNames!.push(item);
      }
      this.evidenceLinkId = _data['evidenceLinkId'];
      this.evidencePathText = _data['evidencePathText'];
      this.condition = _data['condition'];
      if (Array.isArray(_data['values'])) {
        this.values = [] as any;
        for (let item of _data['values']) this.values!.push(item);
      }
      this.rowGroupId = _data['rowGroupId'];
      this.displayOrder = _data['displayOrder'];
    }
  }

  static fromJS(data: any): DocumentationRequiredRuleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentationRequiredRuleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['operator'] = this.operator;
    data['groupId'] = this.groupId;
    data['groupName'] = this.groupName;
    if (Array.isArray(this.ruleIds)) {
      data['ruleIds'] = [];
      for (let item of this.ruleIds) data['ruleIds'].push(item);
    }
    if (Array.isArray(this.ruleNames)) {
      data['ruleNames'] = [];
      for (let item of this.ruleNames) data['ruleNames'].push(item);
    }
    data['evidenceLinkId'] = this.evidenceLinkId;
    data['evidencePathText'] = this.evidencePathText;
    data['condition'] = this.condition;
    if (Array.isArray(this.values)) {
      data['values'] = [];
      for (let item of this.values) data['values'].push(item);
    }
    data['rowGroupId'] = this.rowGroupId;
    data['displayOrder'] = this.displayOrder;
    return data;
  }
}

export interface IDocumentationRequiredRuleResponse {
  id?: string | undefined;
  operator?: string | undefined;
  groupId?: number;
  groupName?: string | undefined;
  ruleIds?: number[] | undefined;
  ruleNames?: string[] | undefined;
  evidenceLinkId?: string | undefined;
  evidencePathText?: string | undefined;
  condition?: string | undefined;
  values?: string[] | undefined;
  rowGroupId?: string | undefined;
  displayOrder?: number;
}

export class DocumentationRequiredRuleSnapshotResponse implements IDocumentationRequiredRuleSnapshotResponse {
  icdCodes?: string[] | undefined;
  severity?: number;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  ruleGroupId?: number;
  groupName?: string | undefined;
  ruleName?: string | undefined;

  constructor(data?: IDocumentationRequiredRuleSnapshotResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(item);
      }
      this.severity = _data['severity'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.groupName = _data['groupName'];
      this.ruleName = _data['ruleName'];
    }
  }

  static fromJS(data: any): DocumentationRequiredRuleSnapshotResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentationRequiredRuleSnapshotResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item);
    }
    data['severity'] = this.severity;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    data['ruleGroupId'] = this.ruleGroupId;
    data['groupName'] = this.groupName;
    data['ruleName'] = this.ruleName;
    return data;
  }
}

export interface IDocumentationRequiredRuleSnapshotResponse {
  icdCodes?: string[] | undefined;
  severity?: number;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  ruleGroupId?: number;
  groupName?: string | undefined;
  ruleName?: string | undefined;
}

export class GapTabConfiguration implements IGapTabConfiguration {
  key?: string | undefined;
  isFixed?: boolean;

  constructor(data?: IGapTabConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.isFixed = _data['isFixed'];
    }
  }

  static fromJS(data: any): GapTabConfiguration {
    data = typeof data === 'object' ? data : {};
    let result = new GapTabConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['isFixed'] = this.isFixed;
    return data;
  }
}

export interface IGapTabConfiguration {
  key?: string | undefined;
  isFixed?: boolean;
}

export class GetTemplateResponse implements IGetTemplateResponse {
  template?: TemplateResponse;
  versions?: TemplateVersionResponse[] | undefined;

  constructor(data?: IGetTemplateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.template = _data['template'] ? TemplateResponse.fromJS(_data['template']) : (undefined as any);
      if (Array.isArray(_data['versions'])) {
        this.versions = [] as any;
        for (let item of _data['versions']) this.versions!.push(TemplateVersionResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetTemplateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetTemplateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['template'] = this.template ? this.template.toJSON() : (undefined as any);
    if (Array.isArray(this.versions)) {
      data['versions'] = [];
      for (let item of this.versions) data['versions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetTemplateResponse {
  template?: TemplateResponse;
  versions?: TemplateVersionResponse[] | undefined;
}

export class GlobalVariableRequest implements IGlobalVariableRequest {
  globalVariableId?: number;
  key!: string;
  value?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;

  constructor(data?: IGlobalVariableRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.globalVariableId = _data['globalVariableId'];
      this.key = _data['key'];
      this.value = _data['value'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): GlobalVariableRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GlobalVariableRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['globalVariableId'] = this.globalVariableId;
    data['key'] = this.key;
    data['value'] = this.value;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IGlobalVariableRequest {
  globalVariableId?: number;
  key: string;
  value?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
}

export class GlobalVariableResponse implements IGlobalVariableResponse {
  globalVariableId?: number;
  key?: string | undefined;
  value?: string | undefined;
  description?: string | undefined;

  constructor(data?: IGlobalVariableResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.globalVariableId = _data['globalVariableId'];
      this.key = _data['key'];
      this.value = _data['value'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): GlobalVariableResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GlobalVariableResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['globalVariableId'] = this.globalVariableId;
    data['key'] = this.key;
    data['value'] = this.value;
    data['description'] = this.description;
    return data;
  }
}

export interface IGlobalVariableResponse {
  globalVariableId?: number;
  key?: string | undefined;
  value?: string | undefined;
  description?: string | undefined;
}

export class HealthCheckResponse implements IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;

  constructor(data?: IHealthCheckResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.timestamp = _data['timestamp'];
      this.version = _data['version'];
      this.environment = _data['environment'];
      if (_data['details']) {
        this.details = {} as any;
        for (let key in _data['details']) {
          if (_data['details'].hasOwnProperty(key)) (this.details as any)![key] = _data['details'][key];
        }
      }
    }
  }

  static fromJS(data: any): HealthCheckResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HealthCheckResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['timestamp'] = this.timestamp;
    data['version'] = this.version;
    data['environment'] = this.environment;
    if (this.details) {
      data['details'] = {};
      for (let key in this.details) {
        if (this.details.hasOwnProperty(key)) (data['details'] as any)[key] = (this.details as any)[key];
      }
    }
    return data;
  }
}

export interface IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;
}

export class LockStatusDto implements ILockStatusDto {
  isLocked?: boolean;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;

  constructor(data?: ILockStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isLocked = _data['isLocked'];
      this.lockedBy = _data['lockedBy'];
      this.isLockedByCurrentUser = _data['isLockedByCurrentUser'];
    }
  }

  static fromJS(data: any): LockStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isLocked'] = this.isLocked;
    data['lockedBy'] = this.lockedBy;
    data['isLockedByCurrentUser'] = this.isLockedByCurrentUser;
    return data;
  }
}

export interface ILockStatusDto {
  isLocked?: boolean;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class Question implements IQuestion {
  questionText?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  gapTabs?: GapTabConfiguration[] | undefined;

  constructor(data?: IQuestion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionText = _data['questionText'];
      this.isRequired = _data['isRequired'];
      this.isVisible = _data['isVisible'];
      this.pdfExport = _data['pdfExport'];
      this.isAiExtractionEnabled = _data['isAiExtractionEnabled'];
      if (Array.isArray(_data['gapTabs'])) {
        this.gapTabs = [] as any;
        for (let item of _data['gapTabs']) this.gapTabs!.push(GapTabConfiguration.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Question {
    data = typeof data === 'object' ? data : {};
    let result = new Question();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['questionText'] = this.questionText;
    data['isRequired'] = this.isRequired;
    data['isVisible'] = this.isVisible;
    data['pdfExport'] = this.pdfExport;
    data['isAiExtractionEnabled'] = this.isAiExtractionEnabled;
    if (Array.isArray(this.gapTabs)) {
      data['gapTabs'] = [];
      for (let item of this.gapTabs) data['gapTabs'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IQuestion {
  questionText?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  gapTabs?: GapTabConfiguration[] | undefined;
}

export class RejectConfigurationRequest implements IRejectConfigurationRequest {
  reviewComments?: string | undefined;

  constructor(data?: IRejectConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reviewComments = _data['reviewComments'];
    }
  }

  static fromJS(data: any): RejectConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RejectConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reviewComments'] = this.reviewComments;
    return data;
  }
}

export interface IRejectConfigurationRequest {
  reviewComments?: string | undefined;
}

export class RejectTemplateRequest implements IRejectTemplateRequest {
  reviewComments?: string | undefined;

  constructor(data?: IRejectTemplateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reviewComments = _data['reviewComments'];
    }
  }

  static fromJS(data: any): RejectTemplateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RejectTemplateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reviewComments'] = this.reviewComments;
    return data;
  }
}

export interface IRejectTemplateRequest {
  reviewComments?: string | undefined;
}

export class SaveTemplateClinicalRuleConfigurationRequest implements ISaveTemplateClinicalRuleConfigurationRequest {
  rules?: TemplateClinicalRuleSelectionRequest[] | undefined;
  documentationRequiredRules?: TemplateDocumentationRequiredRuleRequest[] | undefined;

  constructor(data?: ISaveTemplateClinicalRuleConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['rules'])) {
        this.rules = [] as any;
        for (let item of _data['rules']) this.rules!.push(TemplateClinicalRuleSelectionRequest.fromJS(item));
      }
      if (Array.isArray(_data['documentationRequiredRules'])) {
        this.documentationRequiredRules = [] as any;
        for (let item of _data['documentationRequiredRules'])
          this.documentationRequiredRules!.push(TemplateDocumentationRequiredRuleRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SaveTemplateClinicalRuleConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SaveTemplateClinicalRuleConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.rules)) {
      data['rules'] = [];
      for (let item of this.rules) data['rules'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.documentationRequiredRules)) {
      data['documentationRequiredRules'] = [];
      for (let item of this.documentationRequiredRules)
        data['documentationRequiredRules'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISaveTemplateClinicalRuleConfigurationRequest {
  rules?: TemplateClinicalRuleSelectionRequest[] | undefined;
  documentationRequiredRules?: TemplateDocumentationRequiredRuleRequest[] | undefined;
}

export class SaveTemplateRequest implements ISaveTemplateRequest {
  templateId?: number;
  templateName!: string;
  templateDescription?: string | undefined;
  assessmentTypeId?: number;
  assessmentStrategyTypeId?: number;
  templateVersionId?: number | undefined;
  version?: number | undefined;
  templateStatusId?: number | undefined;
  questionnaireId?: string | undefined;
  sourceTemplateVersionId?: number | undefined;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  comments?: string | undefined;

  constructor(data?: ISaveTemplateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
      this.templateName = _data['templateName'];
      this.templateDescription = _data['templateDescription'];
      this.assessmentTypeId = _data['assessmentTypeId'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.templateVersionId = _data['templateVersionId'];
      this.version = _data['version'];
      this.templateStatusId = _data['templateStatusId'];
      this.questionnaireId = _data['questionnaireId'];
      this.sourceTemplateVersionId = _data['sourceTemplateVersionId'];
      this.submitComments = _data['submitComments'];
      this.reviewComments = _data['reviewComments'];
      this.submittedBy = _data['submittedBy'];
      this.submittedDate = _data['submittedDate'];
      this.approvedBy = _data['approvedBy'];
      this.approvedDate = _data['approvedDate'];
      this.rejectedBy = _data['rejectedBy'];
      this.rejectedDate = _data['rejectedDate'];
      this.comments = _data['comments'];
    }
  }

  static fromJS(data: any): SaveTemplateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SaveTemplateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    data['templateName'] = this.templateName;
    data['templateDescription'] = this.templateDescription;
    data['assessmentTypeId'] = this.assessmentTypeId;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['templateVersionId'] = this.templateVersionId;
    data['version'] = this.version;
    data['templateStatusId'] = this.templateStatusId;
    data['questionnaireId'] = this.questionnaireId;
    data['sourceTemplateVersionId'] = this.sourceTemplateVersionId;
    data['submitComments'] = this.submitComments;
    data['reviewComments'] = this.reviewComments;
    data['submittedBy'] = this.submittedBy;
    data['submittedDate'] = this.submittedDate;
    data['approvedBy'] = this.approvedBy;
    data['approvedDate'] = this.approvedDate;
    data['rejectedBy'] = this.rejectedBy;
    data['rejectedDate'] = this.rejectedDate;
    data['comments'] = this.comments;
    return data;
  }
}

export interface ISaveTemplateRequest {
  templateId?: number;
  templateName: string;
  templateDescription?: string | undefined;
  assessmentTypeId?: number;
  assessmentStrategyTypeId?: number;
  templateVersionId?: number | undefined;
  version?: number | undefined;
  templateStatusId?: number | undefined;
  questionnaireId?: string | undefined;
  sourceTemplateVersionId?: number | undefined;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  comments?: string | undefined;
}

export class SaveTemplateResponse implements ISaveTemplateResponse {
  templateId?: number;

  constructor(data?: ISaveTemplateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
    }
  }

  static fromJS(data: any): SaveTemplateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SaveTemplateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    return data;
  }
}

export interface ISaveTemplateResponse {
  templateId?: number;
}

export class SearchConfigurationRequest implements ISearchConfigurationRequest {
  templateId?: number;
  statusIds?: number[] | undefined;
  searchText?: string | undefined;
  sortBy?: string | undefined;
  sortDirection?: string | undefined;

  constructor(data?: ISearchConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
      if (Array.isArray(_data['statusIds'])) {
        this.statusIds = [] as any;
        for (let item of _data['statusIds']) this.statusIds!.push(item);
      }
      this.searchText = _data['searchText'];
      this.sortBy = _data['sortBy'];
      this.sortDirection = _data['sortDirection'];
    }
  }

  static fromJS(data: any): SearchConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    if (Array.isArray(this.statusIds)) {
      data['statusIds'] = [];
      for (let item of this.statusIds) data['statusIds'].push(item);
    }
    data['searchText'] = this.searchText;
    data['sortBy'] = this.sortBy;
    data['sortDirection'] = this.sortDirection;
    return data;
  }
}

export interface ISearchConfigurationRequest {
  templateId?: number;
  statusIds?: number[] | undefined;
  searchText?: string | undefined;
  sortBy?: string | undefined;
  sortDirection?: string | undefined;
}

export class SearchSortParams implements ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;

  constructor(data?: ISearchSortParams) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.searchText = _data['searchText'];
      if (Array.isArray(_data['searchColumns'])) {
        this.searchColumns = [] as any;
        for (let item of _data['searchColumns']) this.searchColumns!.push(item);
      }
      this.sortColumn = _data['sortColumn'];
      this.sortDirection = _data['sortDirection'];
    }
  }

  static fromJS(data: any): SearchSortParams {
    data = typeof data === 'object' ? data : {};
    let result = new SearchSortParams();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['searchText'] = this.searchText;
    if (Array.isArray(this.searchColumns)) {
      data['searchColumns'] = [];
      for (let item of this.searchColumns) data['searchColumns'].push(item);
    }
    data['sortColumn'] = this.sortColumn;
    data['sortDirection'] = this.sortDirection;
    return data;
  }
}

export interface ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;
}

export class Section implements ISection {
  name?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  questions?: Question[] | undefined;
  subSections?: SubSection[] | undefined;

  constructor(data?: ISection) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.isRequired = _data['isRequired'];
      this.isVisible = _data['isVisible'];
      this.pdfExport = _data['pdfExport'];
      this.isAiExtractionEnabled = _data['isAiExtractionEnabled'];
      if (Array.isArray(_data['questions'])) {
        this.questions = [] as any;
        for (let item of _data['questions']) this.questions!.push(Question.fromJS(item));
      }
      if (Array.isArray(_data['subSections'])) {
        this.subSections = [] as any;
        for (let item of _data['subSections']) this.subSections!.push(SubSection.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Section {
    data = typeof data === 'object' ? data : {};
    let result = new Section();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['isRequired'] = this.isRequired;
    data['isVisible'] = this.isVisible;
    data['pdfExport'] = this.pdfExport;
    data['isAiExtractionEnabled'] = this.isAiExtractionEnabled;
    if (Array.isArray(this.questions)) {
      data['questions'] = [];
      for (let item of this.questions) data['questions'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.subSections)) {
      data['subSections'] = [];
      for (let item of this.subSections) data['subSections'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISection {
  name?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  questions?: Question[] | undefined;
  subSections?: SubSection[] | undefined;
}

export class SubSection implements ISubSection {
  name?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  questions?: Question[] | undefined;

  constructor(data?: ISubSection) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.isRequired = _data['isRequired'];
      this.isVisible = _data['isVisible'];
      this.pdfExport = _data['pdfExport'];
      this.isAiExtractionEnabled = _data['isAiExtractionEnabled'];
      if (Array.isArray(_data['questions'])) {
        this.questions = [] as any;
        for (let item of _data['questions']) this.questions!.push(Question.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SubSection {
    data = typeof data === 'object' ? data : {};
    let result = new SubSection();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['isRequired'] = this.isRequired;
    data['isVisible'] = this.isVisible;
    data['pdfExport'] = this.pdfExport;
    data['isAiExtractionEnabled'] = this.isAiExtractionEnabled;
    if (Array.isArray(this.questions)) {
      data['questions'] = [];
      for (let item of this.questions) data['questions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISubSection {
  name?: string | undefined;
  isRequired?: boolean;
  isVisible?: boolean;
  pdfExport?: boolean;
  isAiExtractionEnabled?: boolean;
  questions?: Question[] | undefined;
}

export class SubmitConfigurationForApprovalRequest implements ISubmitConfigurationForApprovalRequest {
  templateId?: number;
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  configJson?: string | undefined;
  submitComments?: string | undefined;
  effectiveDate?: string;
  isDeactivate?: boolean;
  nonOverrideClientConfigIds?: number[] | undefined;

  constructor(data?: ISubmitConfigurationForApprovalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
      if (Array.isArray(_data['clientIds'])) {
        this.clientIds = [] as any;
        for (let item of _data['clientIds']) this.clientIds!.push(item);
      }
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      this.configJson = _data['configJson'];
      this.submitComments = _data['submitComments'];
      this.effectiveDate = _data['effectiveDate'];
      this.isDeactivate = _data['isDeactivate'];
      if (Array.isArray(_data['nonOverrideClientConfigIds'])) {
        this.nonOverrideClientConfigIds = [] as any;
        for (let item of _data['nonOverrideClientConfigIds']) this.nonOverrideClientConfigIds!.push(item);
      }
    }
  }

  static fromJS(data: any): SubmitConfigurationForApprovalRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SubmitConfigurationForApprovalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    if (Array.isArray(this.clientIds)) {
      data['clientIds'] = [];
      for (let item of this.clientIds) data['clientIds'].push(item);
    }
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    data['configJson'] = this.configJson;
    data['submitComments'] = this.submitComments;
    data['effectiveDate'] = this.effectiveDate;
    data['isDeactivate'] = this.isDeactivate;
    if (Array.isArray(this.nonOverrideClientConfigIds)) {
      data['nonOverrideClientConfigIds'] = [];
      for (let item of this.nonOverrideClientConfigIds) data['nonOverrideClientConfigIds'].push(item);
    }
    return data;
  }
}

export interface ISubmitConfigurationForApprovalRequest {
  templateId?: number;
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  configJson?: string | undefined;
  submitComments?: string | undefined;
  effectiveDate?: string;
  isDeactivate?: boolean;
  nonOverrideClientConfigIds?: number[] | undefined;
}

export class TemplateApprovalResponse implements ITemplateApprovalResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  approvedBy?: string | undefined;
  approvedDate?: string;
  reviewComments?: string | undefined;
  isPublished?: boolean;
  questionnaireId?: string;

  constructor(data?: ITemplateApprovalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.templateId = _data['templateId'];
      this.version = _data['version'];
      this.templateStatusId = _data['templateStatusId'];
      this.approvedBy = _data['approvedBy'];
      this.approvedDate = _data['approvedDate'];
      this.reviewComments = _data['reviewComments'];
      this.isPublished = _data['isPublished'];
      this.questionnaireId = _data['questionnaireId'];
    }
  }

  static fromJS(data: any): TemplateApprovalResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateApprovalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['templateId'] = this.templateId;
    data['version'] = this.version;
    data['templateStatusId'] = this.templateStatusId;
    data['approvedBy'] = this.approvedBy;
    data['approvedDate'] = this.approvedDate;
    data['reviewComments'] = this.reviewComments;
    data['isPublished'] = this.isPublished;
    data['questionnaireId'] = this.questionnaireId;
    return data;
  }
}

export interface ITemplateApprovalResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  approvedBy?: string | undefined;
  approvedDate?: string;
  reviewComments?: string | undefined;
  isPublished?: boolean;
  questionnaireId?: string;
}

export class TemplateArchiveResponse implements ITemplateArchiveResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  archivedBy?: string | undefined;
  archivedDate?: string;
  questionnaireId?: string;

  constructor(data?: ITemplateArchiveResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.templateId = _data['templateId'];
      this.version = _data['version'];
      this.templateStatusId = _data['templateStatusId'];
      this.archivedBy = _data['archivedBy'];
      this.archivedDate = _data['archivedDate'];
      this.questionnaireId = _data['questionnaireId'];
    }
  }

  static fromJS(data: any): TemplateArchiveResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateArchiveResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['templateId'] = this.templateId;
    data['version'] = this.version;
    data['templateStatusId'] = this.templateStatusId;
    data['archivedBy'] = this.archivedBy;
    data['archivedDate'] = this.archivedDate;
    data['questionnaireId'] = this.questionnaireId;
    return data;
  }
}

export interface ITemplateArchiveResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  archivedBy?: string | undefined;
  archivedDate?: string;
  questionnaireId?: string;
}

export class TemplateClinicalRuleResponse implements ITemplateClinicalRuleResponse {
  templateVersionId?: number;
  doNotCodeRuleConfig?: DoNotCodeRuleCategoryConfigurationResponse;
  conflictDiagnosisRuleConfig?: ConflictingDiagnosisRuleCategoryConfigurationResponse;
  documentationRequiredRulesConfig?: DocumentationRequiredConfigurationResponse;

  constructor(data?: ITemplateClinicalRuleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.doNotCodeRuleConfig = _data['doNotCodeRuleConfig']
        ? DoNotCodeRuleCategoryConfigurationResponse.fromJS(_data['doNotCodeRuleConfig'])
        : (undefined as any);
      this.conflictDiagnosisRuleConfig = _data['conflictDiagnosisRuleConfig']
        ? ConflictingDiagnosisRuleCategoryConfigurationResponse.fromJS(_data['conflictDiagnosisRuleConfig'])
        : (undefined as any);
      this.documentationRequiredRulesConfig = _data['documentationRequiredRulesConfig']
        ? DocumentationRequiredConfigurationResponse.fromJS(_data['documentationRequiredRulesConfig'])
        : (undefined as any);
    }
  }

  static fromJS(data: any): TemplateClinicalRuleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateClinicalRuleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['doNotCodeRuleConfig'] = this.doNotCodeRuleConfig ? this.doNotCodeRuleConfig.toJSON() : (undefined as any);
    data['conflictDiagnosisRuleConfig'] = this.conflictDiagnosisRuleConfig
      ? this.conflictDiagnosisRuleConfig.toJSON()
      : (undefined as any);
    data['documentationRequiredRulesConfig'] = this.documentationRequiredRulesConfig
      ? this.documentationRequiredRulesConfig.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface ITemplateClinicalRuleResponse {
  templateVersionId?: number;
  doNotCodeRuleConfig?: DoNotCodeRuleCategoryConfigurationResponse;
  conflictDiagnosisRuleConfig?: ConflictingDiagnosisRuleCategoryConfigurationResponse;
  documentationRequiredRulesConfig?: DocumentationRequiredConfigurationResponse;
}

export class TemplateClinicalRuleSelectionRequest implements ITemplateClinicalRuleSelectionRequest {
  ruleId?: number;
  displayOrder?: number;
  isActive?: boolean;

  constructor(data?: ITemplateClinicalRuleSelectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.displayOrder = _data['displayOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): TemplateClinicalRuleSelectionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateClinicalRuleSelectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['displayOrder'] = this.displayOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface ITemplateClinicalRuleSelectionRequest {
  ruleId?: number;
  displayOrder?: number;
  isActive?: boolean;
}

export class TemplateConfigurationHistoryLookupRequest implements ITemplateConfigurationHistoryLookupRequest {
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  templateId?: number;

  constructor(data?: ITemplateConfigurationHistoryLookupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['clientIds'])) {
        this.clientIds = [] as any;
        for (let item of _data['clientIds']) this.clientIds!.push(item);
      }
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      this.templateId = _data['templateId'];
    }
  }

  static fromJS(data: any): TemplateConfigurationHistoryLookupRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateConfigurationHistoryLookupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.clientIds)) {
      data['clientIds'] = [];
      for (let item of this.clientIds) data['clientIds'].push(item);
    }
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    data['templateId'] = this.templateId;
    return data;
  }
}

export interface ITemplateConfigurationHistoryLookupRequest {
  clientIds?: number[] | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  templateId?: number;
}

export class TemplateDocumentationRequiredRuleRequest implements ITemplateDocumentationRequiredRuleRequest {
  ruleId?: number;
  rowGroupId?: string | undefined;
  displayOrder?: number;
  operator?: string | undefined;
  evidenceLinkId?: string | undefined;
  evidencePathText?: string | undefined;
  condition?: string | undefined;
  values?: string[] | undefined;
  isActive?: boolean;

  constructor(data?: ITemplateDocumentationRequiredRuleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.rowGroupId = _data['rowGroupId'];
      this.displayOrder = _data['displayOrder'];
      this.operator = _data['operator'];
      this.evidenceLinkId = _data['evidenceLinkId'];
      this.evidencePathText = _data['evidencePathText'];
      this.condition = _data['condition'];
      if (Array.isArray(_data['values'])) {
        this.values = [] as any;
        for (let item of _data['values']) this.values!.push(item);
      }
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): TemplateDocumentationRequiredRuleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateDocumentationRequiredRuleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['rowGroupId'] = this.rowGroupId;
    data['displayOrder'] = this.displayOrder;
    data['operator'] = this.operator;
    data['evidenceLinkId'] = this.evidenceLinkId;
    data['evidencePathText'] = this.evidencePathText;
    data['condition'] = this.condition;
    if (Array.isArray(this.values)) {
      data['values'] = [];
      for (let item of this.values) data['values'].push(item);
    }
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface ITemplateDocumentationRequiredRuleRequest {
  ruleId?: number;
  rowGroupId?: string | undefined;
  displayOrder?: number;
  operator?: string | undefined;
  evidenceLinkId?: string | undefined;
  evidencePathText?: string | undefined;
  condition?: string | undefined;
  values?: string[] | undefined;
  isActive?: boolean;
}

export class TemplateListItem implements ITemplateListItem {
  id?: number;
  name?: string | undefined;
  lastModifiedBy?: string | undefined;
  lastModifiedDate?: string | undefined;
  statusId?: number | undefined;
  version?: number | undefined;
  templateVersionId?: number | undefined;
  questionnaireId?: string | undefined;
  comments?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  assessmentStrategyTypeId?: number | undefined;
  assessmentStrategyType?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;
  versions?: TemplateVersionItem[] | undefined;

  constructor(data?: ITemplateListItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.lastModifiedBy = _data['lastModifiedBy'];
      this.lastModifiedDate = _data['lastModifiedDate'];
      this.statusId = _data['statusId'];
      this.version = _data['version'];
      this.templateVersionId = _data['templateVersionId'];
      this.questionnaireId = _data['questionnaireId'];
      this.comments = _data['comments'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.assessmentStrategyType = _data['assessmentStrategyType'];
      this.lockedBy = _data['lockedBy'];
      this.isLockedByCurrentUser = _data['isLockedByCurrentUser'];
      if (Array.isArray(_data['versions'])) {
        this.versions = [] as any;
        for (let item of _data['versions']) this.versions!.push(TemplateVersionItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TemplateListItem {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateListItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['lastModifiedBy'] = this.lastModifiedBy;
    data['lastModifiedDate'] = this.lastModifiedDate;
    data['statusId'] = this.statusId;
    data['version'] = this.version;
    data['templateVersionId'] = this.templateVersionId;
    data['questionnaireId'] = this.questionnaireId;
    data['comments'] = this.comments;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['assessmentStrategyType'] = this.assessmentStrategyType;
    data['lockedBy'] = this.lockedBy;
    data['isLockedByCurrentUser'] = this.isLockedByCurrentUser;
    if (Array.isArray(this.versions)) {
      data['versions'] = [];
      for (let item of this.versions) data['versions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ITemplateListItem {
  id?: number;
  name?: string | undefined;
  lastModifiedBy?: string | undefined;
  lastModifiedDate?: string | undefined;
  statusId?: number | undefined;
  version?: number | undefined;
  templateVersionId?: number | undefined;
  questionnaireId?: string | undefined;
  comments?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  assessmentStrategyTypeId?: number | undefined;
  assessmentStrategyType?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;
  versions?: TemplateVersionItem[] | undefined;
}

export class TemplateListItemPagedResult implements ITemplateListItemPagedResult {
  items?: TemplateListItem[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: ITemplateListItemPagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TemplateListItem.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): TemplateListItemPagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateListItemPagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface ITemplateListItemPagedResult {
  items?: TemplateListItem[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class TemplateListRequest implements ITemplateListRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  status?: string | undefined;
  templateName?: string | undefined;
  modifiedBy?: string | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  clientIds?: number[] | undefined;

  constructor(data?: ITemplateListRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.status = _data['status'];
      this.templateName = _data['templateName'];
      this.modifiedBy = _data['modifiedBy'];
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      if (Array.isArray(_data['clientIds'])) {
        this.clientIds = [] as any;
        for (let item of _data['clientIds']) this.clientIds!.push(item);
      }
    }
  }

  static fromJS(data: any): TemplateListRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateListRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['status'] = this.status;
    data['templateName'] = this.templateName;
    data['modifiedBy'] = this.modifiedBy;
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    if (Array.isArray(this.clientIds)) {
      data['clientIds'] = [];
      for (let item of this.clientIds) data['clientIds'].push(item);
    }
    return data;
  }
}

export interface ITemplateListRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  status?: string | undefined;
  templateName?: string | undefined;
  modifiedBy?: string | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  clientIds?: number[] | undefined;
}

export class TemplateListResponse implements ITemplateListResponse {
  templateId?: number;
  templateName?: string | undefined;
  publishedTemplateVersionId?: number | undefined;
  assessmentStrategyTypeId?: number;
  status?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;

  constructor(data?: ITemplateListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
      this.templateName = _data['templateName'];
      this.publishedTemplateVersionId = _data['publishedTemplateVersionId'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.status = _data['status'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
    }
  }

  static fromJS(data: any): TemplateListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    data['templateName'] = this.templateName;
    data['publishedTemplateVersionId'] = this.publishedTemplateVersionId;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['status'] = this.status;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    return data;
  }
}

export interface ITemplateListResponse {
  templateId?: number;
  templateName?: string | undefined;
  publishedTemplateVersionId?: number | undefined;
  assessmentStrategyTypeId?: number;
  status?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
}

export class TemplateListResponsePagedResult implements ITemplateListResponsePagedResult {
  items?: TemplateListResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: ITemplateListResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TemplateListResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): TemplateListResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateListResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface ITemplateListResponsePagedResult {
  items?: TemplateListResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class TemplateRejectionResponse implements ITemplateRejectionResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  rejectedBy?: string | undefined;
  rejectedDate?: string;
  reviewComments?: string | undefined;
  questionnaireId?: string;

  constructor(data?: ITemplateRejectionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.templateId = _data['templateId'];
      this.version = _data['version'];
      this.templateStatusId = _data['templateStatusId'];
      this.rejectedBy = _data['rejectedBy'];
      this.rejectedDate = _data['rejectedDate'];
      this.reviewComments = _data['reviewComments'];
      this.questionnaireId = _data['questionnaireId'];
    }
  }

  static fromJS(data: any): TemplateRejectionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateRejectionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['templateId'] = this.templateId;
    data['version'] = this.version;
    data['templateStatusId'] = this.templateStatusId;
    data['rejectedBy'] = this.rejectedBy;
    data['rejectedDate'] = this.rejectedDate;
    data['reviewComments'] = this.reviewComments;
    data['questionnaireId'] = this.questionnaireId;
    return data;
  }
}

export interface ITemplateRejectionResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  rejectedBy?: string | undefined;
  rejectedDate?: string;
  reviewComments?: string | undefined;
  questionnaireId?: string;
}

export class TemplateResponse implements ITemplateResponse {
  templateId?: number;
  templateName?: string | undefined;
  templateDescription?: string | undefined;
  assessmentTypeId?: number;
  assessmentStrategyTypeId?: number;
  publishedTemplateVersionId?: number | undefined;
  publishedTemplateVersion?: number | undefined;
  publishedQuestionnaireId?: string | undefined;
  sourceTemplateVersionId?: number | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;

  constructor(data?: ITemplateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateId = _data['templateId'];
      this.templateName = _data['templateName'];
      this.templateDescription = _data['templateDescription'];
      this.assessmentTypeId = _data['assessmentTypeId'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.publishedTemplateVersionId = _data['publishedTemplateVersionId'];
      this.publishedTemplateVersion = _data['publishedTemplateVersion'];
      this.publishedQuestionnaireId = _data['publishedQuestionnaireId'];
      this.sourceTemplateVersionId = _data['sourceTemplateVersionId'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
    }
  }

  static fromJS(data: any): TemplateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateId'] = this.templateId;
    data['templateName'] = this.templateName;
    data['templateDescription'] = this.templateDescription;
    data['assessmentTypeId'] = this.assessmentTypeId;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['publishedTemplateVersionId'] = this.publishedTemplateVersionId;
    data['publishedTemplateVersion'] = this.publishedTemplateVersion;
    data['publishedQuestionnaireId'] = this.publishedQuestionnaireId;
    data['sourceTemplateVersionId'] = this.sourceTemplateVersionId;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    return data;
  }
}

export interface ITemplateResponse {
  templateId?: number;
  templateName?: string | undefined;
  templateDescription?: string | undefined;
  assessmentTypeId?: number;
  assessmentStrategyTypeId?: number;
  publishedTemplateVersionId?: number | undefined;
  publishedTemplateVersion?: number | undefined;
  publishedQuestionnaireId?: string | undefined;
  sourceTemplateVersionId?: number | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
}

export class TemplateSearchRequest implements ITemplateSearchRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  status?: string | undefined;
  modifiedBy?: string | undefined;
  createdBy?: string | undefined;
  assessmentStrategyTypeId?: number | undefined;
  createdDateFrom?: string | undefined;
  createdDateTo?: string | undefined;
  lastModifiedDateFrom?: string | undefined;
  lastModifiedDateTo?: string | undefined;

  constructor(data?: ITemplateSearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.status = _data['status'];
      this.modifiedBy = _data['modifiedBy'];
      this.createdBy = _data['createdBy'];
      this.assessmentStrategyTypeId = _data['assessmentStrategyTypeId'];
      this.createdDateFrom = _data['createdDateFrom'];
      this.createdDateTo = _data['createdDateTo'];
      this.lastModifiedDateFrom = _data['lastModifiedDateFrom'];
      this.lastModifiedDateTo = _data['lastModifiedDateTo'];
    }
  }

  static fromJS(data: any): TemplateSearchRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['status'] = this.status;
    data['modifiedBy'] = this.modifiedBy;
    data['createdBy'] = this.createdBy;
    data['assessmentStrategyTypeId'] = this.assessmentStrategyTypeId;
    data['createdDateFrom'] = this.createdDateFrom;
    data['createdDateTo'] = this.createdDateTo;
    data['lastModifiedDateFrom'] = this.lastModifiedDateFrom;
    data['lastModifiedDateTo'] = this.lastModifiedDateTo;
    return data;
  }
}

export interface ITemplateSearchRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  status?: string | undefined;
  modifiedBy?: string | undefined;
  createdBy?: string | undefined;
  assessmentStrategyTypeId?: number | undefined;
  createdDateFrom?: string | undefined;
  createdDateTo?: string | undefined;
  lastModifiedDateFrom?: string | undefined;
  lastModifiedDateTo?: string | undefined;
}

export class TemplateUniquenessResponse implements ITemplateUniquenessResponse {
  isUnique?: boolean;

  constructor(data?: ITemplateUniquenessResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isUnique = _data['isUnique'];
    }
  }

  static fromJS(data: any): TemplateUniquenessResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateUniquenessResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isUnique'] = this.isUnique;
    return data;
  }
}

export interface ITemplateUniquenessResponse {
  isUnique?: boolean;
}

export class TemplateVersionItem implements ITemplateVersionItem {
  templateVersionId?: number;
  version?: number;
  statusId?: number;
  questionnaireId?: string;
  comments?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  lastModifiedBy?: string | undefined;
  lastModifiedDate?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;

  constructor(data?: ITemplateVersionItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.version = _data['version'];
      this.statusId = _data['statusId'];
      this.questionnaireId = _data['questionnaireId'];
      this.comments = _data['comments'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.lastModifiedBy = _data['lastModifiedBy'];
      this.lastModifiedDate = _data['lastModifiedDate'];
      this.lockedBy = _data['lockedBy'];
      this.isLockedByCurrentUser = _data['isLockedByCurrentUser'];
    }
  }

  static fromJS(data: any): TemplateVersionItem {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateVersionItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['version'] = this.version;
    data['statusId'] = this.statusId;
    data['questionnaireId'] = this.questionnaireId;
    data['comments'] = this.comments;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['lastModifiedBy'] = this.lastModifiedBy;
    data['lastModifiedDate'] = this.lastModifiedDate;
    data['lockedBy'] = this.lockedBy;
    data['isLockedByCurrentUser'] = this.isLockedByCurrentUser;
    return data;
  }
}

export interface ITemplateVersionItem {
  templateVersionId?: number;
  version?: number;
  statusId?: number;
  questionnaireId?: string;
  comments?: string | undefined;
  createdBy?: string | undefined;
  createdDate?: string | undefined;
  lastModifiedBy?: string | undefined;
  lastModifiedDate?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;
}

export class TemplateVersionResponse implements ITemplateVersionResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  questionnaireId?: string;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  archivedBy?: string | undefined;
  archivedDate?: string | undefined;
  createdDate?: string;
  createdBy?: string | undefined;
  modifiedDate?: string;
  modifiedBy?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;

  constructor(data?: ITemplateVersionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.templateVersionId = _data['templateVersionId'];
      this.templateId = _data['templateId'];
      this.version = _data['version'];
      this.templateStatusId = _data['templateStatusId'];
      this.questionnaireId = _data['questionnaireId'];
      this.submitComments = _data['submitComments'];
      this.reviewComments = _data['reviewComments'];
      this.submittedBy = _data['submittedBy'];
      this.submittedDate = _data['submittedDate'];
      this.approvedBy = _data['approvedBy'];
      this.approvedDate = _data['approvedDate'];
      this.rejectedBy = _data['rejectedBy'];
      this.rejectedDate = _data['rejectedDate'];
      this.archivedBy = _data['archivedBy'];
      this.archivedDate = _data['archivedDate'];
      this.createdDate = _data['createdDate'];
      this.createdBy = _data['createdBy'];
      this.modifiedDate = _data['modifiedDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.lockedBy = _data['lockedBy'];
      this.isLockedByCurrentUser = _data['isLockedByCurrentUser'];
    }
  }

  static fromJS(data: any): TemplateVersionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateVersionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['templateVersionId'] = this.templateVersionId;
    data['templateId'] = this.templateId;
    data['version'] = this.version;
    data['templateStatusId'] = this.templateStatusId;
    data['questionnaireId'] = this.questionnaireId;
    data['submitComments'] = this.submitComments;
    data['reviewComments'] = this.reviewComments;
    data['submittedBy'] = this.submittedBy;
    data['submittedDate'] = this.submittedDate;
    data['approvedBy'] = this.approvedBy;
    data['approvedDate'] = this.approvedDate;
    data['rejectedBy'] = this.rejectedBy;
    data['rejectedDate'] = this.rejectedDate;
    data['archivedBy'] = this.archivedBy;
    data['archivedDate'] = this.archivedDate;
    data['createdDate'] = this.createdDate;
    data['createdBy'] = this.createdBy;
    data['modifiedDate'] = this.modifiedDate;
    data['modifiedBy'] = this.modifiedBy;
    data['lockedBy'] = this.lockedBy;
    data['isLockedByCurrentUser'] = this.isLockedByCurrentUser;
    return data;
  }
}

export interface ITemplateVersionResponse {
  templateVersionId?: number;
  templateId?: number;
  version?: number;
  templateStatusId?: number;
  questionnaireId?: string;
  submitComments?: string | undefined;
  reviewComments?: string | undefined;
  submittedBy?: string | undefined;
  submittedDate?: string | undefined;
  approvedBy?: string | undefined;
  approvedDate?: string | undefined;
  rejectedBy?: string | undefined;
  rejectedDate?: string | undefined;
  archivedBy?: string | undefined;
  archivedDate?: string | undefined;
  createdDate?: string;
  createdBy?: string | undefined;
  modifiedDate?: string;
  modifiedBy?: string | undefined;
  lockedBy?: string | undefined;
  isLockedByCurrentUser?: boolean;
}

export class UpdateRequestJsonRequest implements IUpdateRequestJsonRequest {
  configJson?: string | undefined;
  submitComments?: string | undefined;

  constructor(data?: IUpdateRequestJsonRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.configJson = _data['configJson'];
      this.submitComments = _data['submitComments'];
    }
  }

  static fromJS(data: any): UpdateRequestJsonRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateRequestJsonRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['configJson'] = this.configJson;
    data['submitComments'] = this.submitComments;
    return data;
  }
}

export interface IUpdateRequestJsonRequest {
  configJson?: string | undefined;
  submitComments?: string | undefined;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
